<div class="content-block">
  <div class="responsive-paddings">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12 login-header">
          <ng-container *ngFor="let logo of logoSettings; let noBorder = last">
            <img *ngIf="noBorder" alt="{{ logo }}" class="{{ logo }}-logo" src="./assets/img/logos/{{ logo }}.png" style="height: 50px" />
            <img *ngIf="!noBorder" alt="{{ logo }}" class="{{ logo }}-logo logo-border" src="./assets/img/logos/{{ logo }}.png" />
          </ng-container>
        </div>
      </div>
      <div class="justify-content-center row">
        <nida-web-password-management
          [headerName]="'settings.changeUserPassword.changePassword' | transloco"
          [buttonName]="'settings.changeUserPassword.changePassword' | transloco"
          [requireCurrentPassword]="false"
          [redirect]="true"
          [nidaMobile]="false"
        ></nida-web-password-management>
      </div>
    </div>
  </div>
</div>
